module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADsSURBVHgBjVPRDYIwEG2N/+IGHQE3wA0YATdwAxnBDRgBNyBOgBugE4AT1HfJIzaFll5yefTuvTvSuyoVMWttBr/Be/gA7+CVxNWWgZRTNFLYEC3jJiY2JC2IXi4LFajZyQTyBfNXHSB0gK/WunRiA+CN2JnnHvDZqXUz8NGLTVLAOx/2gQKSPLoBdD55nGz1D2RsgBz+UgEDpyTnsRDzcuqIuJinkCR25t9woSzRBMWcdesIWhYRrDY7c13tvLoqZiR1XudB1CrB/CkUcLlhmcBFpRga3e3/gYz83n5tNFmkmt8H4hNLM6UW+AEuETQ3WhNuggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottery/icon-password.png
// module id = n+F2
// module chunks = 0